import React from 'react';
import './Astrology.scss';
import  Globals from '../../api' ;
import Rightbar from "../../components/Rightbar/Rightbar";
import ROS_Middle_Center_728_90 from '../ad-units/ros_middle_center_728_90';
import ROS_Top_Center_728_90 from '../ad-units/Ros_top_center_728_90';
 export default class Astrology extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            AstroData  : [],
            HorroscopeNavigation : [],
            HoroscopeTerm : [],
            Terms : [],
            Horoscopes : [],
            meta : [] ,
            title : [],
            meta_keywords : [],
            meta_description : [],
            HoroscopeNavigationItems : [],
            HoroscopeDescription : [],
            Rightbar : [],
            AdData :[]
         };
      }
      getRightbar(){
        const url= Globals.Rightbar_api+"/astrology-articles-in-kannada";
        fetch(url)
            .then((res) => res.json())
            .then((data) => {

                this.setState({
                    Rightbar: data.Contents[0]
                })
            })
    }
    getAds() {
        const url = Globals.AdConfig;
        fetch(url)
            .then((res) => res.json())
            .then((data) => {

                this.setState({
                    AdData: data.AdContents[0].ROS
                })

            })

    }
    componentDidMount() {
        let URI = window.location.pathname + window.location.search;
        //console.log(URI);
           const url= Globals.language_based_api+URI;
           fetch(url)
           .then((res) => res.json())
           .then((data) => {
             
               this.setState({
                AstroData : data.Contents[2],
                Horoscopes : data.Contents[2].Horoscopes,
                HoroscopeNavigation : data.Contents[2].HoroscopeNavigation.Selected,
                HoroscopeNavigationItems : data.Contents[2].HoroscopeNavigation,
                Terms : data.Contents[2].Terms,
                HoroscopeTerm : data.Contents[2].Term,
                HoroscopeDescription : data.Contents[2].HoroscopeDescription ,
                 meta : data.Meta ,
                 title : data.Title,
                 meta_keywords : data.Meta.keywords.Attributes.content,
                 meta_description : data.Meta.description.Attributes.content
               })
           }) 
           this.getRightbar();
           this.getAds();
         }
         handleChange (e) {
            window.location = e.target.value;
            
          }
    render() {
        let Horoscopes = this.state.Horoscopes;
        let HoroscopeNavigation = this.state.HoroscopeNavigation;
        let HoroscopeTerms = this.state.Terms;
        let SelectedTerm = this.state.HoroscopeTerm;
        let Selected = SelectedTerm.Value;
        let HoroscopeNavigationItems = this.state.HoroscopeNavigationItems;
        let DailyTitle = HoroscopeNavigationItems.DailyTitle;
        let WeeklyTitle = HoroscopeNavigationItems.WeeklyTitle;
        let MonthlyTitle = HoroscopeNavigationItems.MonthlyTitle;
        let YearlyTitle = HoroscopeNavigationItems.YearlyTitle;
       
        const HoroscopeTermsBar =   HoroscopeTerms.map((item,i)=>{  
            return(
           <option value={item.Url} selected={Selected == item.Value}>{item.Title}</option>
            )});

        const HoroscopeItems = Horoscopes.map((item, i) =>
            <div className="astrology_block">
                <span className="astro_icon"><img src={"https://hindi.webdunia.com/img/new-zodiac-signs/zdc" + item.RashiID + ".png"} /></span>
                <div className="astro_content">
                    <h3>{item.RashiName}</h3>
                    <div className="rashichar">{item.RashiChar}</div>
                    <div className="rashiDesc">
                    <p>{item.Horoscope}</p>
                    </div>
                    {(item.More == true) ? <p><a href={item.DetailUrl}>{item.MoreText}</a></p> : ""}
                    <p><a href={"/astrology" + item.PhaladeshUrl}>{item.PhaladeshText}</a></p>

                </div>
            </div>
        );
        return (
            <div className="astrology_page">
                <div className="container padding15">
                    <div className="row">
                        <div className="col">
                            {/* <ul className="wdbreadcrumb ">
                                <li><a href="#">धर्म-संसार</a></li>
                                <li><a href="#">ज्योतिष</a></li>
                                <li>दैनिक-राशिफल</li>
                            </ul> */}
                            <div className="astrology_container m-t-10">
                                
                                <ul className="astro_buttons">
                                    
                                    <li className = {(HoroscopeNavigation == "Daily") ? 'daily_rashi active' : 'daily_rashi' }><a href="/astrology-daily-horoscope">{DailyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Weekly") ? 'week_rashi active' : 'week_rashi' }><a href="/astrology-weekly-horoscope">{WeeklyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Monthly") ? 'month_rashi active' : 'month_rashi' }><a href="/astrology-monthly-horoscope">{MonthlyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Yearly") ? 'year_rashi active' : 'year_rashi' }><a href="/astrology-yearly-horoscope">{YearlyTitle}</a></li>
                                </ul>

                                <div className="astro_head">
                                    <h2>{(HoroscopeNavigation == "Daily") ? DailyTitle : (HoroscopeNavigation == "Weekly") ? WeeklyTitle :
                                    (HoroscopeNavigation == "Monthly") ? MonthlyTitle :  YearlyTitle 
                                    }</h2>
                                    <div className="astro_select_date">
                                        <span>Select Date : </span>
                                        <select onChange={this.handleChange}>
                                           {HoroscopeTermsBar}
                                        </select>
                                    </div>
                                </div>
                                <p>{this.state.HoroscopeDescription}</p>
                                <div className="astro_block_list">
                                    {HoroscopeItems}       
                                </div>
                               
                            </div>
                            <div className="ads_block m-t-15"  >
                            <ROS_Middle_Center_728_90 AdData= {this.state.AdData} />
                            </div>
                        </div>
                        <div className="col right_side_bar">
                        <Rightbar Rightbar = {this.state.Rightbar} googleAds ={this.state.AdData} />
                            
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
